export enum GroupPrivate {
  True = 1,
  False = 0,
}
